import { company } from '../config/company';
import './About.css';

const highlights = [
  {
    title: 'Hong Kong Based',
    text: 'Registered and headquartered in Wan Chai, Hong Kong, at the heart of Asia’s digital economy.',
  },
  {
    title: 'Digital Content Focus',
    text: 'Specialized in web fiction and mobile reading products for international markets.',
  },
  {
    title: 'Global Reach',
    text: 'Serving readers across Southeast Asia, the Americas and Europe with localized experiences.',
  },
];

function About() {
  return (
    <section className="section section--soft about" id="about">
      <div className="container">
        <h2 className="section__title">About Us</h2>
        <p className="section__subtitle">Who we are</p>

        <div className="about__grid">
          <div className="about__intro">
            <p className="about__text">
              {company.name} ({company.nameZh}) is a digital content company
              based in Hong Kong. We build mobile reading products that
              connect great stories with readers around the world.
            </p>
            <p className="about__text">
              Our flagship product, TideRead, delivers licensed web fiction
              to overseas markets with localized, reader-first experiences.
              We believe stories flow like tides - crossing borders,
              reaching everywhere, never ending.
            </p>
            <div className="about__address">
              <h3 className="about__address-title">Contact &amp; Address</h3>
              <p className="about__text">
                <strong className="about__contact-label">Email</strong>
                <br />
                {company.contact.email}
              </p>
              <p className="about__text">
                <strong className="about__contact-label">Phone</strong>
                <br />
                {company.contact.phone}
              </p>
              <p className="about__text">
                <strong className="about__contact-label">Address</strong>
                <br />
                {company.address.line1}
                <br />
                {company.address.line2}
                <br />
                {company.address.line3}
              </p>
            </div>
          </div>

          <div className="about__highlights">
            {highlights.map((item) => (
              <div className="about__highlight" key={item.title}>
                <h3 className="about__highlight-title">{item.title}</h3>
                <p className="about__text">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
